export const buildPortinaxForm = ({
  item,
  value,
  is_active,
  saved_form_inputs_test,
  saved_form_fees_details_test,
  saved_form_CardTypes,
  convertIntoArray,
  type,
}: any) => {
  return {
    ...item?.inputs,
    is_live: value === undefined ? false : value,
    is_active: is_active,
    test_endpoint: item?.test_endpoint
        ? item?.test_endpoint
        : saved_form_fees_details_test[0]?.test_endpoint,
    live_endpoint: item?.live_endpoint
        ? item?.live_endpoint
        : saved_form_fees_details_test[0]?.live_endpoint,
        advanced_avs : {
        validate_address  : item?.advanced_avs?.validate_address || false,
        validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
        validate_email  : item?.advanced_avs?.validate_email || false,
        validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
        },
    velocity: {
        transaction_limit: {
        allow_transaction_limit:
            item?.velocity?.transaction_limit
            ?.allow_transaction_limit || false,
        limit_no: item?.velocity?.transaction_limit?.limit_no || "",
        period: item?.velocity?.transaction_limit?.period || "",
        },
        blocked_countries: {
        allow_blocked_countries:
            item?.velocity?.blocked_countries
            ?.allow_blocked_countries || false,
        country_code:
            item?.velocity?.blocked_countries?.country_code || [],
        },
        blocked_countries_bin: {
        allow_blocked_countries_bin:
            item?.velocity?.blocked_countries_bin
            ?.allow_blocked_countries_bin || false,
        country_code:
            item?.velocity?.blocked_countries_bin?.country_code || [],
        },
        max_transaction_limit: {
        allow_max_transaction_limit:
            item?.velocity?.max_transaction_limit
            ?.allow_max_transaction_limit || false,
        limit_amount:
            item?.velocity?.max_transaction_limit?.limit_amount || "",
        currency:
            item?.velocity?.max_transaction_limit?.currency || "",
        },
        min_transaction_limit: {
        allow_min_transaction_limit:
            item?.velocity?.min_transaction_limit
            ?.allow_min_transaction_limit || false,
        limit_amount:
            item?.velocity?.min_transaction_limit?.limit_amount || "",
        currency:
            item?.velocity?.min_transaction_limit?.currency || "",
        },
        max_transaction_period: {
        allow_max_transaction_period:
            item?.velocity?.max_transaction_period
            ?.allow_max_transaction_period || false,
        limit_amount:
            item?.velocity?.max_transaction_period?.limit_amount ||
            "",
        currency:
            item?.velocity?.max_transaction_period?.currency || "",
        period:
            item?.velocity?.max_transaction_period?.period || "",
        },
        retry_time: {
        allow_retry_time:
            item?.velocity?.retry_time?.allow_retry_time || false,
        limit_minutes:
            item?.velocity?.retry_time?.limit_minutes || "",
        },
        max_attempts_day: {
        allow_max_attempts_day:
            item?.velocity?.max_attempts_day
            ?.allow_max_attempts_day || false,
        limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
        },
        max_attempts_week: {
        allow_max_attempts_week:
            item?.velocity?.max_attempts_week
            ?.allow_max_attempts_week || false,
        limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
        },
        max_attempts_month: {
        allow_max_attempts_month:
            item?.velocity?.max_attempts_month
            ?.allow_max_attempts_month || false,
        limit_no:
            item?.velocity?.max_attempts_month?.limit_no || "",
        },
        max_attempts_total: {
        allow_max_attempts_total:
            item?.velocity?.max_attempts_total
            ?.allow_max_attempts_total || false,
        limit_no:
            item?.velocity?.max_attempts_total?.limit_no || "",
        },
    },
    merchant_key_test: item?.inputs?.merchant_key_test
        ? item?.inputs?.merchant_key_test
        : saved_form_inputs_test?.merchant_key_test,
    merchant_key_live: item?.inputs?.merchant_key_live
        ? item?.inputs?.merchant_key_live
        : "",
    password_test: item?.inputs?.password_test
        ? item?.inputs?.password_test
        : saved_form_inputs_test?.password_test,
    password_live: item?.inputs?.password_live
        ? item?.inputs?.password_live
        : "",
    client_card_types:
        // item?.reserved_pricing?.client_card_types || [],
        item?.reserved_pricing?.client_card_types?.map((m: any) => {
        return {
            card_name: m?.card_name,
            percentage_fee: m?.percentage_fee,
            fixed_fee: m?.fixed_fee,
            currency_code: m?.currency_code,
            allow_card: m?.allow_card,

            cost_percentage_fee:
            item?.cost?.client_card_types?.filter(
                (f: any) => f?.card_name == m?.card_name
            )[0]?.percentage_fee || "",
            cost_fixed_fee:
            item?.cost?.client_card_types?.filter(
                (f: any) => f?.card_name == m?.card_name
            )[0]?.fixed_fee || "",
            cost_currency_code: item?.cost?.client_card_types?.filter(
            (f: any) => f?.card_name == m?.card_name
            )[0]?.currency_code,
        };
        }),
    // additional_fees: item?.reserved_pricing?.additional_fees || {},
    additional_fees: {
        chargeback_fees:
        item?.reserved_pricing?.additional_fees?.chargeback_fees,
        dispute_fees:
        item?.reserved_pricing?.additional_fees?.dispute_fees,
        reserve_fees:
        item?.reserved_pricing?.additional_fees?.reserve_fees,
        refunded_tnx_fees:
        item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
        declined_tnx_fees:
        item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
        cost_chargeback_fees:
        item?.cost?.additional_fees?.chargeback_fees,
        cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
        cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
        cost_refunded_tnx_fees:
        item?.cost?.additional_fees?.refunded_tnx_fees,
        cost_declined_tnx_fees:
        item?.cost?.additional_fees?.declined_tnx_fees,
    },
    cardTypes: saved_form_CardTypes,
    payout_fees: item?.payout_fees || {},
    wallet_ids: item?.wallet_ids || [],
    ewallet_New_addressess: [],
    disCard_walletes: [],
    fess_conditions: {
        apm: saved_form_fees_details_test[0]?.apm,
        payout: saved_form_fees_details_test[0]?.payout,
        payin: saved_form_fees_details_test[0]?.payin,
    },
    payment_methods: item?.payment_method
        ? item?.payment_method?.filterPaymentMethod
        : convertIntoArray(saved_form_fees_details_test),
    gateway_method_fees:
        // item?.reserved_pricing?.gateway_method_fees || {},
        {
        apm_fees:
            item?.reserved_pricing?.gateway_method_fees?.apm_fees,
        cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
        payout_fees:
            item?.reserved_pricing?.gateway_method_fees?.payout_fees,
        cost_payout_fees:
            item?.reserved_pricing?.gateway_method_fees?.payout_fees,
        payin_fees:
            item?.reserved_pricing?.gateway_method_fees?.payin_fees,
        cost_payin_fees:
            item?.reserved_pricing?.gateway_method_fees?.payin_fees,
        },
    type: type,
    whitelist_enabled: item?.whitelist_enabled,
  };
};